import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Login from "../views/Login.vue";
import Singup from "../views/Singup.vue";
import ValidarEmail from "../views/ValidarEmail.vue";
import Obras from "../views/Obras.vue";
import Tramites from "../views/Tramites.vue";
import Regalias from "../views/Regalias.vue";
import SetPassword from "../views/SetPassword.vue";
import store from "../store/index";
import MisDatos from "@/components/misdatos/MisDatos.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    meta: {
      title: "Socios"
    },
    name: "Home",
    component: Home
  },
  {
    path: "/obras",
    meta: {
      title: "Obras"
    },
    name: "Obras",
    component: Obras
  },
  {
    path: "/singup",
    meta: {
      title: "Nuevo Usuario"
    },
    name: "Singup",
    component: Singup
  },
  {
    path: "/login",
    meta: {
      title: "Inicio de Sesión"
    },
    name: "Login",
    component: Login
  },
  {
    path: "/validarEmail",
    meta: {
      title: "Verificar correo"
    },
    name: "VerificarCorreo",
    component: ValidarEmail
  },
  {
    path: "/regalias",
    meta: {
      title: "Regalías",
      auth: true
    },
    name: "Regalias",
    component: Regalias
  },
  {
    path: "/tramites",
    meta: {
      title: "Trámites",
      auth: true
    },
    name: "Tramites",
    component: Tramites
  },
  {
    path: "/setPassword",
    meta: {
      title: "Establecer contraseña",
      auth: true
    },
    name: "EstablecerContraseña",
    component: SetPassword
  },
  {
    path: "/misdatos",
    meta: {
      title: "Mis Datos",
      auth: true
    },
    name: "MisDatos",
    component: MisDatos
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (
    to.path.startsWith("/singup") ||
    to.path.startsWith("/validarEmail") ||
    to.path.startsWith("/setPassword") ||
    to.path.startsWith("/login") ||
    to.path.startsWith("/test")
  ) {
    next();
  } else {
    if (store.state.user) {
      next();
    } else {
      next("/login");
    }
  }

  if (to.meta.title) {
    document.title = to.meta.title + "..::..Autores Paraguayos Asociados";
  } else {
    document.title = "Socios..::..Autores Paraguayos Asociados";
  }
});

export default router;
